import React from 'react';
import { Calendar } from '../../../../node_modules/web-ui-components/lib/atoms/forms';
import { Content } from '../../../infrastructure/content';
import moment from 'moment';
import { getValidationMessage } from '../utils/dateUtils';

const DateComponent = ({ selectedDate, onDateChange, isPristine, validationType }) => {
  return (
    <Content>
      {({ switchDateError = '' }) => (
        <Calendar
          labelTitle={''}
          disableWeekends
          dateFormat="DD-MM-YYYY"
          validationText={getValidationMessage(isPristine, validationType, switchDateError)}
          minDate={moment()}
          selected={selectedDate}
          onChange={onDateChange}
        />
      )}
    </Content>
  );
};

export default DateComponent;
